import React from 'react';
import SnackBar from '@material-ui/core/Snackbar';
const StatusBar = ({ message = '', clearStatus }) => (<SnackBar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={!!message} autoHideDuration={6000} onClose={clearStatus} ContentProps={{
    'aria-describedby': 'message-id',
}} message={<span id="message-id">{message}</span>}/>);
export default StatusBar;
